/** Display-only basis. Never use this to collect, refund, or calculate payouts. */
export function hostPriceTotal(value: {
  rentalFee?: unknown; baseRentalFee?: unknown; deliveryFee?: unknown;
  serviceFee?: unknown; insuranceFee?: unknown;
}): number | null {
  const parts = [value.baseRentalFee ?? value.rentalFee, value.deliveryFee, value.serviceFee, value.insuranceFee];
  if (parts.some(v => v == null || v === "" || !Number.isFinite(Number(v)) || Number(v) < 0)) return null;
  return Math.round(parts.reduce<number>((sum, v) => sum + Number(v), 0) * 100) / 100;
}

/** Missing evidence must not become a fabricated zero. */
export function knownEarnings(value: unknown): number | null {
  if (value == null || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) && n >= 0 ? n : null;
}

/** Display an unconfirmed request's identified expected earnings without
 * claiming it is committed, or overriding a known root amount (including 0). */
export function expectedHostEarnings(trip: {
  status?: string | null; owner_earn?: unknown; initial_request_owner_earn?: unknown;
} | null | undefined): number | null {
  return knownEarnings(trip?.owner_earn) ??
    (trip?.status === "pending" ? knownEarnings(trip.initial_request_owner_earn) : null);
}
